export default "__VITE_ASSET__pCpBRGoG__"